import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T, t } from '@sm/intl';
import { Banner } from '@wds/banner';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { IconCheck, IconTrash } from '@wds/icons';
const COPY = {
  AcceptRejectChangesDescription: {
    id: 'buildWithAI.AcceptRejectChangesBanner.AcceptRejectChangesDescription',
    defaultMessage: '<b>Review the changes below based on your prompt:</b> “{prompt}”',
    description: '[Type: Label][Vis: high] - cue to accept or reject modifications made to the survey and display the prompt they used to modify the survey'
  },
  AcceptChangesButton: {
    id: 'buildWithAI.AcceptRejectChangesBanner.AcceptChangesButton',
    defaultMessage: 'Accept changes',
    description: '[Type: Button][Vis: high] - button for user to accept changes'
  },
  RejectChangesButton: {
    id: 'buildWithAI.AcceptRejectChangesBanner.RejectChangesButton',
    defaultMessage: 'Reject changes',
    description: '[Type: Button][Vis: high] - button for user to reject changes'
  },
  IconCheck: {
    id: 'buildWithAI.AcceptRejectChangesBanner.IconCheck',
    defaultMessage: 'Check icon',
    description: '[Type: Label][Vis: med] - icon to accept changes'
  },
  IconTrash: {
    id: 'buildWithAI.AcceptRejectChangesBanner.IconTrash',
    defaultMessage: 'Trash icon',
    description: '[Type: Label][Vis: med] - icon to reject changes'
  }
};
const useStyles = createUseStyles(theme => ({
  container: {
    '& b': {
      fontWeight: '500'
    }
  }
}));
const AcceptRejectChangesBanner = ({
  onAcceptChanges,
  onRejectChanges,
  prompt,
  show
}) => {
  const {
    container
  } = useStyles();
  return _jsxs(Banner, {
    color: "success",
    show: show,
    showIcon: true,
    children: [_jsx(Box, {
      className: container,
      display: "flex",
      children: _jsx(Typography, {
        children: _jsx(T, {
          desc: COPY.AcceptRejectChangesDescription,
          values: {
            prompt: prompt
          },
          html: true
        })
      })
    }), _jsxs(Box, {
      display: "flex",
      mt: 3,
      children: [_jsx(Box, {
        mr: 2,
        children: _jsxs(Button, {
          onClick: onAcceptChanges,
          children: [_jsx(IconCheck, {
            title: t(COPY.IconCheck)
          }), _jsx(T, {
            desc: COPY.AcceptChangesButton
          })]
        })
      }), _jsxs(Button, {
        color: "warning",
        onClick: onRejectChanges,
        children: [_jsx(IconTrash, {
          title: t(COPY.IconTrash)
        }), _jsx(T, {
          desc: COPY.RejectChangesButton
        })]
      })]
    })]
  });
};
export default AcceptRejectChangesBanner;